/** Base URL of the headless WordPress instance (GraphQL, REST, media uploads). */
export const WP_URL = import.meta.env.VITE_WP_URL ?? 'http://localhost:8080'

/** Public base URL of this site, used for canonical/hreflang/OG tags and the sitemap. */
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'https://titantop.ru').replace(/\/$/, '')
